export class DocumentPagination {
  /**
   * The pagination form
   *
   * @protected
   */
  protected form: HTMLFormElement | null;

  /**
   * The pagination label items (mouse events)
   *
   * @protected
   */
  protected paginationLabelItems?: NodeListOf<HTMLLabelElement>;

  /**
   * The pagination input items (keyboard events)
   *
   * @protected
   */
  protected paginationRadioItems?: NodeListOf<HTMLInputElement>;

  /**
   * Calendar options
   *
   * @protected
   */
  protected options: PaginationOptions;

  constructor(options = {}) {
    const defaults: PaginationOptions = {
      wrapperClass: 'publications__form-pagination',
      itemsRadioClass: 'publication__page-item-radio',
      itemsLabelClass: 'publication__page-item-radio-label',
    };

    this.options = {
      ...defaults,
      ...options,
    };

    this.form = document.querySelector(`.${this.options.wrapperClass}`);

    if (this.form !== null) {
      this.initialize();
    }
  }

  protected initialize() {
    this.paginationLabelItems = this.form?.querySelectorAll(`.${this.options.itemsLabelClass}`) as NodeListOf<HTMLLabelElement>;
    this.paginationRadioItems = this.form?.querySelectorAll(`.${this.options.itemsRadioClass}`) as NodeListOf<HTMLInputElement>;

    if (this.paginationLabelItems !== null) {
      this.initPaginationMouseEvents();
    }

    if (this.paginationRadioItems !== null) {
      this.initPaginationKeyboardEvents();
    }
  }

  protected initPaginationMouseEvents() {
    this.paginationLabelItems?.forEach(item => {
      item.addEventListener('mouseup', () => {
        const radioInput = this.form?.querySelector(`#${item.getAttribute('for')}`) as HTMLInputElement;
        if (radioInput !== null) {
          radioInput.checked = true;
        }
        this.form?.submit();
      });
    });
  }

  protected initPaginationKeyboardEvents() {
    this.paginationRadioItems?.forEach(item => {
      item.addEventListener('keyup', (event) => {
        if (event.code === 'Space' || event.code === 'Enter') {
          this.form?.submit();
        }
      });
    });
  }
}

export interface PaginationOptions {
  wrapperClass?: string;
  itemsRadioClass?: string;
  itemsLabelClass?: string;
}



